var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'core', 'model/base'], function($, core, BaseModel) {
  var AddressModel;
  return AddressModel = (function(_super) {

    __extends(AddressModel, _super);

    function AddressModel() {
      AddressModel.__super__.constructor.apply(this, arguments);
    }

    AddressModel.prototype.pathRoot = core.getConfig().apiPrefix + 'address.json';

    AddressModel.prototype.defaults = function() {
      return {
        id: null,
        streetLine1: '',
        streetLine2: '',
        city: '',
        province: '',
        postalCode: '',
        contactPersonFirstName: '',
        contactPersonLastName: '',
        phone: '',
        countryId: null
      };
    };

    return AddressModel;

  })(BaseModel);
});
